import { Component, Input, inject } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { BehaviorSubject, combineLatest, from, of, switchMap } from 'rxjs';

import { PermissionService } from 'src/app/core/services/permission.service';

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.scss'],
  imports: [NgIf, AsyncPipe],
})
export class PermissionComponent {
  private permissionService = inject(PermissionService);

  private role$ = new BehaviorSubject<string>('');
  private permission$ = new BehaviorSubject<string>('');

  show$ = combineLatest([this.role$, this.permission$]).pipe(
    switchMap(([role, permission]) => {
      if (!role || !permission) {
        return of(false);
      }

      return from(this.permissionService.hasPermission(role, permission));
    })
  );

  @Input() set role(value: string) {
    this.role$.next(value || '');
  }

  @Input() set permission(value: string) {
    this.permission$.next(value || '');
  }
}
